import React, { useState } from 'react';
import './Menu.css';

import { MenuItem } from '../../components';
import { menu } from '../../constants';
import { formatCategoryName } from '../../utils';

const MenuSection = () => {

  // State to track the active (selected) category
  const [activeCategory, setActiveCategory] = useState(Object.keys(menu)[0]);

  return (
    <div className="menu-content">

      {/* Menu Category Tabs */}
      <div className="tab-buttons">
        {Object.keys(menu).map(categoryKey => (
          <button
            key={categoryKey}
            type="button"
            className={`button ${activeCategory === categoryKey ? 'active' : ''}`}
            onClick={() => setActiveCategory(categoryKey)} // Update active category on click
          >
            {formatCategoryName(categoryKey)} {/* Format and display the category name */}
          </button>
        ))}
      </div>

      {/* Render only the active category's menu items */}
      <div className="menu-gallery active" id={activeCategory}>
        {menu[activeCategory].map(item => (
          <MenuItem key={`${activeCategory}-${item.id}`} item={item} />
        ))}
      </div>

    </div>
  );
};

export default MenuSection;